import { render, staticRenderFns } from "./StaffRatingSetting.vue?vue&type=template&id=3b5df802"
import script from "./StaffRatingSetting.vue?vue&type=script&lang=js"
export * from "./StaffRatingSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports